<div class="section section-padding">
    <div class="container">
        <div class="section-title text-center">
            <p class="subtitle">05 --- Our Team</p>
            <h4 class="title">Our Experts</h4>
        </div>
        <div class="row">
            <!-- Data -->
            <div class="col-lg-4 col-md-6" *ngFor="let item of teamblock | slice:0:3">
                <div class="sigma_team team-5">
                    <div class="sigma_team-thumb">
                        <img [src]="item.image" [alt]="item.name">
                        <div class="sigma_team-info">
                            <ul class="sigma_sm" [ngClass]="item.visible ? 'visible' : ''">
                                <!-- Data -->
                                <li *ngFor="let social of item.social">
                                    <a routerLink="{{social.url}}"><i [class]="social.icon"></i></a>
                                </li>
                                <!-- Data -->
                                <li> <a href="javascript:void(0)" class="trigger-team-socials" (click)="socialtrigger(item)"> <i class="fal fa-plus"></i> </a> </li>
                            </ul>
                            <h5>{{item.name}}</h5>
                            <p>{{item.post}}</p>
                        </div>
                    </div>
                    <div class="sigma_team-body">
                        <p class="mb-0">{{item.shorttext}}</p>
                    </div>
                </div>
            </div>
            <!-- Data -->
        </div>
    </div>
</div>